import React, { useState } from 'react';
import { exportAuditLogs } from '../../../../../data/mockAuditData';

interface DownloadButtonProps {
  className?: string;
}

const DownloadIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 1v8M4 6l3 3 3-3M2 10v2a1 1 0 001 1h8a1 1 0 001-1v-2" 
          stroke="currentColor" 
          strokeWidth="1.5" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
  </svg>
);

const DownloadButton: React.FC<DownloadButtonProps> = ({ className = '' }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const blob = await exportAuditLogs('csv');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `audit-logs-${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button 
      className={`btn-download-logs ${className}`}
      onClick={handleDownload}
      disabled={isDownloading}
    >
      <DownloadIcon />
      {isDownloading ? 'Downloading...' : 'Download Logs'}
    </button>
  );
};

export default DownloadButton;